import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ElementRef
} from '@angular/core';

// Servicios
import { DragulaService } from 'ng2-dragula';
// Components
import { SxBaseContainerDesigner } from '../../base/base-container-designer-component';
import {
  DesignAttributeType,
  OptionsAttribute,
  AttributeChangeEventArgsType
} from '../../../../types/designer-attribute-type';
import { IDesignerFactoryService } from '../../../../services/designer-factory-interface';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'sx-dynamicAttributeContainer-designer',
  templateUrl: './dynamicAttributeContainer.designer.component.html'
})
export class SxDynamicAttributeContainerDesigner extends SxBaseContainerDesigner
  implements OnInit, OnDestroy {

  constructor(
    dragulaService: DragulaService,
    designerFactoryService: IDesignerFactoryService,
    container: ElementRef,
    public ngxSmartModalService: NgxSmartModalService
  ) {
    super(dragulaService, designerFactoryService, 'SxDynamicAttrContainer', container);
  }

  loadDefaults(): void {
    super.loadDefaults();
    this.controlContext.commandCategory = '';
    this.controlContext.renderColumns = 'Col1';
  }

  getElementModal(instance: any) {
    this.ngxSmartModalService.setModalData(instance, 'attributesModal');
    this.ngxSmartModalService.getModal('attributesModal').open();
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();

    info['title'] = this.controlContext.title;
    info['renderColumns'] = this.controlContext.renderColumns;
    info['commandCategory'] = this.controlContext.commandCategory;

    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();

    const titleAtt = new DesignAttributeType(
      this.controlContext,
      'string',
      'title',
      'Tile'
    );

    const categoryAtt = new DesignAttributeType(
      this.controlContext,
      'string',
      'commandCategory',
      'Category'
    );

    const columnTypes = [
      { id: 'Col1', name: '1 column' },
      { id: 'Col2', name: '2 columns' },
      { id: 'Col3', name: '3 columns' }
    ];

    const collumnattr = new OptionsAttribute(
      this.controlContext,
      columnTypes,
      'renderColumns',
      'Columns'
    );
    collumnattr.change.subscribe(v => this.onColumnAttChange(v));

    this.attributes.push(collumnattr);
    const asyncDependenciesAtt = new DesignAttributeType(
      this.controlContext,
      'string',
      'asyncDisplayDependency',
      'Async display dependency'
    );

    this.attributes.push(
      titleAtt,
      categoryAtt,
      asyncDependenciesAtt,
    );
  }

  onColumnAttChange(args: AttributeChangeEventArgsType): void {
    this.controlContext.renderColumns = args.newValue;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/containers/dynamicAttributeContainer.designer.component.ts